import { useState } from "react";
import { TerminosModal } from "./TerminosModal";
import { Logo } from "./Logo";

const Lock = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" aria-hidden="true"><path strokeLinecap="round" strokeLinejoin="round" d="M16.5 10.5V7a4.5 4.5 0 10-9 0v3.5M6 10.5h12a1.5 1.5 0 011.5 1.5v7.5A1.5 1.5 0 0118 21H6a1.5 1.5 0 01-1.5-1.5V12A1.5 1.5 0 016 10.5z" /></svg>
);

// Bottom of every page: brand, trust line and legal links (the dispute link stays low-key)
const Footer = () => {
  const [showTerminos, setShowTerminos] = useState(false);
  return (
    <footer className="bg-amber-950 text-amber-100/80 text-sm text-left">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10 grid gap-8 md:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <Logo light />
          <p className="mt-4 max-w-sm text-amber-100/70">&ldquo;El bur&oacute; de cr&eacute;dito para inquilinos morosos.&rdquo; Historial de inquilinos hecho por propietarios.</p>
          <p className="mt-4 inline-flex items-center gap-2 text-xs text-amber-200/80 bg-white/5 ring-1 ring-white/10 rounded-full px-3 py-1.5">
            <Lock /> Conexi&oacute;n segura y datos protegidos
          </p>
        </div>
        <div>
          <p className="text-amber-50 font-semibold mb-3">Plataforma</p>
          <ul className="space-y-2">
            <li><a href="/" className="hover:text-white">Buscar inquilino</a></li>
            <li><a href="/registro" className="hover:text-white">Crear cuenta</a></li>
            <li><a href="/login" className="hover:text-white">Iniciar sesi&oacute;n</a></li>
          </ul>
        </div>
        <div>
          <p className="text-amber-50 font-semibold mb-3">Legal</p>
          <ul className="space-y-2">
            <li><button type="button" onClick={() => setShowTerminos(true)} className="hover:text-white">T&eacute;rminos y Condiciones</button></li>
            <li><a href="/privacidad" className="hover:text-white">Aviso de Privacidad</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-4 flex flex-col sm:flex-row gap-2 justify-between text-xs text-amber-100/50">
          <span>&copy; {new Date().getFullYear()} Conoce tu Inquilino</span>
          <a href="/disputas" className="hover:text-amber-100/80">&iquest;Te evaluaron? Disputar una evaluaci&oacute;n</a>
        </div>
      </div>
      {showTerminos && <TerminosModal onClose={() => setShowTerminos(false)} />}
    </footer>
  );
};

export { Footer };
